<div class="card">
  <div class="card-header">
    Local SEO Starter Onboarding
  </div>
  <div class="card-body">
    <a class="btn btn-primary" [href]="onboardingUrl" target="_blank" rel="noopener noreferrer">
      <i class="fas fa-rocket"></i>
      Open Onboarding Page
    </a>
  </div>
</div>
